import React from 'react';
import './App.scss';
import {HomeView} from "./components/views/HomeView/HomeView";

export function App() {

    return (
        <div className="wrapper">
            <HomeView></HomeView>
        </div>
    );
}



